import { UnauthorizedError } from './unauthorizedError';

export class GraphQLTokenService {
  // eslint-disable-next-line
  constructor(private signalError: (e: unknown) => unknown) {}

  public fetchGraphQLToken = ensureSingleRequestInFlight(async () => {
    try {
      // The graphql token cookie is set by the monolith when a request to /manage/refresh_token is made
      await fetch('/manage/refresh_token', {
        method: 'HEAD',
      });
    } catch (e) {
      this.signalError(e);
    }
  });

  public async provideRetry<T>(
    fetcher: () => Promise<T>,
    shouldRetry = isUnauthorizedError
  ) {
    let result!: T;

    try {
      result = await fetcher();
    } catch (e) {
      if (shouldRetry(e)) {
        await this.fetchGraphQLToken();
        result = await fetcher();
      } else {
        throw e;
      }
    }

    return result;
  }
}

function isUnauthorizedError(e: unknown) {
  if (!(e instanceof Error)) return false;

  // NOTE: You cannot assert e.constructor.name === 'UnauthorizedError' expliciatly because the minification of the code turns UnauthorizedError into a random string
  return e.constructor.name === UnauthorizedError.name;
}

function ensureSingleRequestInFlight<T = unknown>(requestFn: () => Promise<T>) {
  let isRequestInFlight = false;
  let lastPromise: Promise<T>;
  const modifiedRequestFn = async () => {
    if (isRequestInFlight) return lastPromise;
    isRequestInFlight = true;
    lastPromise = requestFn();
    await lastPromise;
    isRequestInFlight = false;
    return lastPromise;
  };
  return modifiedRequestFn;
}
